<template>
  <Row class="classList-container " type="flex" :gutter="20">
    <Col v-for="(item, index) in courseList" :key="index" :xs="24" :sm="12" :md="12" :lg="8">
      <div :class="type?'img-classList':'classList'" @click="toDetail(item.objectId)" >
        <!-- 图片 -->
        <img v-if="type" class="picture" :src="item.img">
        <div :class="type?'img-stack':'stack'">
          <!-- 标题 -->
          <div class="titles fbox fbox-ac">
            <p class="title-lable tc fsh m-r-5" v-if="status">{{status.substring(0,2)}}</p>
            <p style="height: 26px" v-else>
              <span class="title-lable tc fsh m-r-5" v-if="item.preinstallMajor && item.preinstallMajor.short">{{item.preinstallMajor.short}}</span>
            </p>
            <p class="fg1 color-black f24 font-weight-b ell">{{item.name}}</p>
          </div>
          <!-- 简介 -->
          <div class="synopsis fbox" v-if="!type">
            <tk-icon class="fsh m-r-5" color="#8e9299" >jihe</tk-icon>
            <div class="ell_2 f16 color-gray fg1">
              {{item.ordinaryCourse || 0}}个基础课程，{{item.kernelCourse || 0}}个核心课程，{{item.expandCourse || 0}}个拓展课程<br />
              <!-- 共{{item.allCourse || parseInt(item.ordinaryCourse) + parseInt(item.kernelCourse) + parseInt(item.expandCourse) || 0}}节课 -->
              共{{item.allPreinstallNum || 0}}个课时
            </div>
          </div>
          <!-- 老师 -->
          <div class="teacherList fbox" v-if="!type">
            <div class="teacher tc" v-for="(teacher, i) in item.teacher" :key="i" v-show="i<3">
              <tk-avatar>
                <tk-image  :src="teacherObj[teacher].headPortrait || 'http://qingbo-oss.oss-cn-beijing.aliyuncs.com/dba81e13-181d-4aa3-b872-bf15d8df199f.png'" width="100" height="100"></tk-image>
              </tk-avatar>
              <p class="tc f16 color-gray">{{teacherObj[teacher].nickname}}</p>
            </div>
          </div>
          <!-- 分割线 -->
          <div class="cut-off-rule" v-if="!type"></div>
          <!-- 按钮 -->
          <div class="btn-box fbox fbox-ac fbox-jb">
            <!-- userDefined按钮 -->
            <div class="fg1 fbox fbox-ac" v-if="type">
              <tk-icon class="fsh m-r-5" color="#8e9299" >jihe</tk-icon>
              <!-- <p class="fg1 f16 color-gray">共{{item.num || 0}}节课</p> -->
              <p class="fg1 f16 color-gray">共{{item.preinstallNum || 0}}个课时</p>
            </div>
            <p v-else class="fg1 f16 color-gray">{{item.applyStudent}}</p>
            <div v-if="type !== 'aiClass'">
              <div class="join success-btn fsh tc f18" v-if="curriculaVariable.indexOf(item.objectId) === -1" @click.stop="joinCourse(item.objectId)" >
                加入选课
              </div>
              <div class="desable desable-btn fsh tc f18" v-else >
                已选此课
              </div>
            </div>
          </div>
        </div>
        <!-- 层叠背景 -->
        <div class="stack-bg" v-if="!type"></div>
      </div>
    </Col>
  </Row>
</template>

<script>
export default {
  name: 'course',
  props: {
    courseList: {
      type: Array
    },
    curriculaVariable: {
      type: Array
    },
    type: {
      type: String
    },
    status: {
      type: String
    },
    teacherObj: {
      type: Object
    }
  },
  data () {
    return {
    }
  },
  mounted () {
  },
  methods: {
    toDetail (id) {
      this.$emit('toDetail', id)
    },
    joinCourse (id) {
      this.$emit('joinCourse', id)
    }
  }
}
</script>

<style lang='scss' scoped>
.classList-container{
  &>div{
    // margin: 0 2%;
    // &:nth-child(3n + 1){
    //   margin-left: 0;
    // }
  }
  .classList{
    width: 100%;
    height: 357px;
    position: relative;
    margin-bottom: 40px;
    border-radius: 4px;
    background: #FFFFFF;
    cursor: pointer;
    .stack{
      width: 100%;
      height: 357px;
      background: #FFFFFF;
      box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.12);
      border-radius: 4px;
      padding: 20px 25px 30px;
      box-sizing: border-box;
      position: absolute;
      z-index: 9;
    }
  }
  .titles{
    width: 100%;
    .title-lable{
      display: inline-block;
      width: 42px;
      height: 26px;
      line-height: 26px;
      background: #DCAF80;
      border-radius: 4px;
      font-size: 16px;
      color: #ffffff;
      font-weight: 400;
    }
  }
  .synopsis{
    margin-top: 10px;
    img{
      width: 29px;
      height: 29px;
      margin-right: 5px;
    }
    div{
      height: 50px;
    }
  }
  .teacherList{
    margin: 30px 0 20px;
    width: 100%;
    height: 79px;
    // overflow-x: scroll;
    .teacher{
      margin-right: 30px;
      img{
        width: 55px;
        height: 55px;
        border-radius: 50%;
      }
    }
  }
  .cut-off-rule{
    width: 100%;
    height: 0px;
    border-top: 1px solid #EBEBEB;
  }
  .btn-box{
    height: 100px;
    div{
      width: 131px;
      height: 50px;
      line-height: 50px;
      font-weight: 400;
    }
  }
  .img-classList{
    width: 100%;
    height: 376px;
    margin-bottom: 40px;
    background: #FFFFFF;
    cursor: pointer;
    box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.12);
    border-radius: 4px;
    overflow: hidden;
    .picture{
      width: 100%;
      height: 222px;
    }
    .img-stack{
      width: 100%;
      height: 154px;
      padding: 15px 25px 30px;
      box-sizing: border-box;
    }

  }
  .stack-bg{
    width: 96%;
    height: 357px;
    box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.12);
    border-radius: 4px;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    bottom: -12px;
    z-index: 0;
    background-color: #fff;
    z-index: 7;
    &::before{
      content: "";
      width: 102%;
      height: 357px;
      box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.1);
      background-color: #fff;
      border-radius: 4px;
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      bottom: 6px;
      z-index: 8;
    }
  }
}
@media(max-width: 992px) {
  .img-classList{
    margin-bottom: 20px !important;
  }
}
</style>
